import createDOMPurify from 'dompurify';

// DOMPurify needs a DOM. In the browser we use the real window; during server-side
// rendering we build one with jsdom. jsdom is loaded via a require the web bundler
// cannot statically see, so it is never pulled into the browser build.
let purifier = null;

const resolvePurifier = () => {
  if (purifier) return purifier;

  // Browser
  if (typeof window !== 'undefined' && window.document) {
    purifier = createDOMPurify(window);
    return purifier;
  }

  // SSR (Node)
  try {
    // Use eval to skip webpack from bundling jsdom in the browser build
    // eslint-disable-next-line no-eval
    const { JSDOM } = eval('require')('jsdom');
    purifier = createDOMPurify(new JSDOM('').window);
  } catch (e) {
    purifier = null;
  }
  return purifier;
};

// Preserve the inline-<style> / CSS code-block feature while stripping scripts,
// event handlers (on*), and javascript: URLs.
// FORCE_BODY keeps top-level <style> blocks (the CSS code-block feature) that DOMPurify
// would otherwise drop from a fragment.
const SANITIZE_CONFIG = { ADD_TAGS: ['style'], ADD_ATTR: ['target'], FORCE_BODY: true };

/**
 * Sanitizes an HTML string before it is injected via dangerouslySetInnerHTML or
 * rendered as raw HTML. Safe to call in both the browser and during SSR.
 * If no DOM is available it fails closed by stripping all tags.
 */
export const sanitizeHtml = dirty => {
  if (dirty == null || dirty === '') return dirty;
  const p = resolvePurifier();
  if (!p || typeof p.sanitize !== 'function') {
    return String(dirty).replace(/<[^>]*>/g, '');
  }
  return p.sanitize(String(dirty), SANITIZE_CONFIG);
};
